import React, { useEffect } from 'react';
import { HeaderText, BodyTextZero } from "../components/text/HeaderText";
import BoxSection from "../components/sections/BoxSection";

const Home = ({ onToggleRAQ, scrollToServicesSection }) => {

  useEffect(() => {
    if (window.location.hash === '#services-section') {
      scrollToServicesSection();
    }
  }, []);

    return (
        <>
        <div className='Home'>
            <div className='HomeContent'>
              <HeaderText />
              <div className='initialText'>
                <BodyTextZero />
              </div>
            </div>
        </div>
        <div className='Services' id="services-section">
          <BoxSection onToggleRAQ={onToggleRAQ}/>
        </div>
        </>
    );
}

export default Home;